import React, { useEffect, useState } from "react";
import "../../admin_resources/css/admin_layout.css";
import "../../admin_resources/css/admin_common.css";
import loginPage from "../../admin_resources/img/back_login.png";
import submitButton from "../../admin_resources/img/regist_submit.png";
import { Link } from "react-router-dom";
import axios from "axios";

const Admin_regist = () => {
  const [formData, setFormData] = useState({
    adminId: "",
    adminPwd: "",
    adminName: "",
    adminDept: "",
    adminEmail: "",
  });

  const [idMessage, setIdMessage] = useState(""); // 아이디 메시지 상태

  useEffect(() => {
    const titleElement = document.getElementsByTagName("title")[0];
    titleElement.innerHTML = `:_:아소비 관리자 등록 :_:`;
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    // 아이디가 변경될 때마다 중복 체크
    if (name === "adminId") {
      checkAdminId(value);
    }
  };

  const checkAdminId = async (adminId) => {
    if (adminId) {
      try {
        const response = await axios.post("/check-id", { adminId });
        setIdMessage(response.data.message); // 메시지 설정
      } catch (error) {
        if (error.response?.status === 409) {
          setIdMessage("이미 존재하는 아이디입니다."); // 중복 아이디 메시지
        } else {
          console.error("중복 체크 오류:", error);
        }
      }
    } else {
      setIdMessage(""); // 입력이 비어있을 경우 메시지 초기화
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (idMessage === "이미 존재하는 아이디입니다.") {
      alert("아이디가 중복되었습니다. 다른 아이디를 입력해주세요.");
      return;
    }

    try {
      const confirmation = window.confirm(`등록 하시겠습니까?`);
      if (!confirmation) {
        return;
      }

      // 사용자 등록 요청
      const response = await axios.post("/register", {
        ...formData,
        adminGubun: "admin",
      });

      if (response.status === 200) {
        alert("가입이 완료되었습니다. 최고관리자 승인 후 사용 가능합니다.");
        window.location.reload();
      }
    } catch (error) {
      console.error("등록 중 오류 발생:", error);
      alert("등록에 실패했습니다. 다시 시도해주세요.");
    }
  };

  return (
    <div>
      <div id="mvisual">
        <div id="greet"></div>
        <div className="wrap">
          <div className="regist_area">
            <h2>
              <font>아소비 관리자 등록</font>
            </h2>
            <br />
            <br />
            <form onSubmit={handleSubmit}>
              <fieldset id="login_level">
                <legend>로그인</legend>
                <table className="tbl_login" cellSpacing="0" summary="로그인">
                  <caption>로그인</caption>
                  <colgroup>
                    <col />
                  </colgroup>
                  <tbody>
                    <tr>
                      <td>
                        <input
                          type="text"
                          id="regid"
                          name="adminId"
                          title="ID"
                          className="input_uid required"
                          tabIndex="1"
                          placeholder="   아이디 입력"
                          value={formData.adminId}
                          onChange={handleChange}
                          required
                        />
                        {idMessage && (
                          <span
                            style={{
                              color: idMessage.includes("존재")
                                ? "red"
                                : "blue",
                              display: "block",
                              marginTop: "5px",
                            }}
                          >
                            {idMessage}
                          </span>
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <input
                          type="password"
                          id="regpwd"
                          name="adminPwd"
                          title="비밀번호"
                          className="input_upw required"
                          tabIndex="2"
                          placeholder="   비밀번호 입력"
                          value={formData.adminPwd}
                          onChange={handleChange}
                          required
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <input
                          type="text"
                          id="regname"
                          name="adminName"
                          title="이름"
                          className="input_uname required"
                          tabIndex="3"
                          placeholder="   이름"
                          value={formData.adminName}
                          onChange={handleChange}
                          required
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <select
                          name="adminDept"
                          id="regdept"
                          className="sel_udept required"
                          title="부서명"
                          value={formData.adminDept}
                          onChange={handleChange}
                          required
                        >
                          <option value="">부서</option>
                          <option value="IT팀">IT팀</option>
                          <option value="경영지원팀">경영지원팀</option>
                          <option value="교육관리팀">교육관리팀</option>
                          <option value="교육부">교육부</option>
                          <option value="교육연구소">교육연구소</option>
                          <option value="교재개발팀">교재개발팀</option>
                          <option value="교재관리팀">교재관리팀</option>
                          <option value="디자인팀">디자인팀</option>
                          <option value="마케팅사업부">마케팅사업부</option>
                          <option value="운영팀">운영팀</option>
                          <option value="출판사업팀">출판사업팀</option>
                          <option value="콘텐츠사업팀">콘텐츠사업팀</option>
                        </select>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <input
                          type="email"
                          id="regmail"
                          name="adminEmail"
                          title="EMAIL"
                          className="input_umail"
                          tabIndex="5"
                          placeholder="   이메일"
                          value={formData.adminEmail}
                          onChange={handleChange}
                          required
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <button type="submit" style={{ marginTop: "30px" }}>
                          <img src={submitButton} id="Regist_btn" alt="등록" />
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </fieldset>
            </form>
            <div>
              <Link to="/admin/admin_login">
                <img src={loginPage} id="back_btn" alt="로그인 페이지" />
              </Link>
            </div>

            <br />
            <p> ※ 최고 관리자 승인 후 사용가능합니다. </p>
          </div>
          <br />
          <div className="sec-footer">
            <font>
              <strong>Copyrightⓒ ASOBI EDUCATION All Rights Reserved.</strong>
            </font>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Admin_regist;
